export default {
  clientes: [],
  clientesActivos: [],
  selectedCliente: null,
  error: false,
  errorMessage: [],
}
